import React, { useEffect, useRef, useState } from 'react';
import { Search } from 'lucide-react';

/**
 * Local input state + debounced callback so parent/table are not rebuilt on every keystroke.
 */
export default function DebouncedSearchField({
    value = '',
    onDebouncedChange,
    placeholder = 'Search...',
    debounceMs = 300,
    wrapperClassName = '',
    inputClassName = ''
}) {
    const [inputVal, setInputVal] = useState(value);
    const debounceRef = useRef(null);

    useEffect(() => {
        setInputVal(value);
    }, [value]);

    useEffect(() => () => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
    }, []);

    const emitChange = (val) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(() => {
            onDebouncedChange(val);
            debounceRef.current = null;
        }, debounceMs);
    };

    const handleChange = (e) => {
        const val = e.target.value;
        setInputVal(val);
        emitChange(val);
    };

    const handleClear = () => {
        setInputVal('');
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
            debounceRef.current = null;
        }
        onDebouncedChange('');
    };

    const hasValue = inputVal && inputVal.trim() !== '';

    return (
        <div className={`tw-relative tw-w-full ${hasValue ? 'has-btn-close' : ''} ${wrapperClassName}`.trim()}>
            <span className="tw-absolute tw-left-3 tw-top-1/2 tw-translate-y-[-50%] tw-text-gray-400">
                <Search size={16} />
            </span>
            <input
                type="text"
                placeholder={placeholder}
                value={inputVal}
                onChange={handleChange}
                className={inputClassName}
            />
            {hasValue && (
                <button
                    type="button"
                    className="btn btn-clear !tw-right-2.5"
                    title="Clear"
                    onClick={handleClear}
                >
                    <i className="icon-close"></i>
                </button>
            )}
        </div>
    );
}
